import { render, staticRenderFns } from "./MyAcademies.vue?vue&type=template&id=d6c232d0&"
import script from "./MyAcademies.vue?vue&type=script&lang=js&"
export * from "./MyAcademies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports